import React from 'react'
import styled, { useTheme } from 'styled-components'
import { LinearProgress } from '@mui/material'
import { Flex, Text, TextVariant } from '@mprolab/uikit'
import dayjs from 'dayjs'
import duration from 'dayjs/plugin/duration'
import UseAnimations from 'react-useanimations'
import loading from 'react-useanimations/lib/loading'
import { displayDuration } from 'utils/displayDuration'

dayjs.extend(duration)

const Progress = styled(LinearProgress)`
  width: 100%;

  border-radius: 12px;
  &.MuiLinearProgress-root {
    color: ${({ theme }) => theme.colors.gray10};
    background: ${({ theme }) => theme.colors.gray8};
    .MuiLinearProgress-bar {
      background: ${({ theme }) => theme.colors.purple};
      border-radius: 12px;
    }
  }
`

const StyledText = styled(Text)`
  white-space: nowrap;
  ${({ theme }) => theme.mediaQueries.mobile} {
    letter-spacing: -0.4px;
  }
`

interface DeclarationCounterProps {
  title: string
  timeUntilEnd: number
  progress: number
  counterLoading?: boolean
  disableCounter?: boolean
}

const DeclarationCounter: React.FC<DeclarationCounterProps> = ({
  title,
  timeUntilEnd,
  progress,
  counterLoading,
  disableCounter
}) => {
  const { colors } = useTheme()

  const formattedTime =
    timeUntilEnd > 0
      ? displayDuration({
          time: timeUntilEnd
        })
      : '--:--:--'

  return (
    <>
      {disableCounter ? (
        <></>
      ) : (
        <Flex mb="16px" flexDirection="column" fullWidth>
          <Flex fullWidth justifyContent="space-between" alignItems="center" flexWrap="wrap">
            <StyledText variant={TextVariant.BODY_SMALL} color={colors.gray6}>
              {title}
            </StyledText>
            {counterLoading ? (
              <UseAnimations animation={loading} strokeColor={colors.gray6} size={16} />
            ) : (
              <StyledText variant={TextVariant.BODY_DEFAULT_BOLD}>{formattedTime}</StyledText>
            )}
          </Flex>
          <Flex fullWidth>
            <Progress variant="determinate" value={progress} />
          </Flex>
        </Flex>
      )}
    </>
  )
}

export default DeclarationCounter
